<template>
    <div class="user">
        <div class="photo">
            <img src="static/img/iconmonstr-user-1-240.png"/>
        </div>
        <div class="info">
            <a>
                <span>{{title}}</span>
            </a>

        </div>
    </div>
</template>
<script>
    import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

    export default {
        components: {
            [CollapseTransition.name]: CollapseTransition
        },
        props: {
            title: {
                type: String,
                default: 'David Montiel'
            }
        },
        data() {
            return {
                isClosed: true
            }
        },
        methods: {
            toggleMenu() {
                this.isClosed = !this.isClosed
            }
        }
    }
</script>
<style>
    .collapsed {
        transition: opacity 1s;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/Extra/UserMenu.vue